import React, { useState, useEffect } from 'react';
import Config from '../../constants/appConfig';
import AppHeader from './header';
import AppFooter from './footer';
import AppContent from './content';
import AppSidenav from './sidenav';

export default ({ history, res, lan, link }) => {

    const menu = "sidenav";

    const [divBack, setDivBack] = useState(false);
    const [showMenu, setShowMenu] = useState(menu);
    const [profile, setProfile] = useState([]);
    const [profileLoaded, setProfileLoaded] = useState(false);
    const [isSmallWindow, setIsSmallWindow] = useState(() => window.innerWidth <= 1024);
    const [menuPinned, setMenuPinned] = useState(true);


    useEffect(() => {
        const root = document.documentElement;
        const body = document.body;
        const previousRootOverflow = root.style.overflow;
        const previousBodyOverflow = body.style.overflow;

        root.style.overflow = 'hidden';
        body.style.overflow = 'hidden';

        return () => {
            root.style.overflow = previousRootOverflow;
            body.style.overflow = previousBodyOverflow;
        };
    }, []);

    useEffect(() => {
        if (link) handleClick(link)
        checkUser();
    }, []);

    useEffect(() => {
        const updateWindowSize = () => setIsSmallWindow(window.innerWidth <= 1024);
        window.addEventListener('resize', updateWindowSize);
        return () => window.removeEventListener('resize', updateWindowSize);
    }, []);

    const handleClick = (link) => {
        if (link === 'back') {
            history.goBack();
        } else {
            history.push(link);
        }
    };

    const checkUser = () => {
        const apiUrl = Config.server + '/currentProfile';
        let obj = {
            method: 'GET',
            headers: {
                'Authorization': localStorage.getItem('access-token-jwt')
            }
        };
        fetch(apiUrl, obj)
            .then((res) => {
                if (res.status !== 200)
                    throw res;//new Error(res.status);
                else
                    return res.json();
            })
            .then(
                (result) => {
                    let array = [];
                    result.forEach(element => {
                        array.push(element.id_profile);
                    });
                    setProfile(array);
                    setProfileLoaded(true);
                },
                (error) => {
                    handleClick('/login');
                }
            );
    }

    const showSidMenu = () => {
        setDivBack(true);
        setShowMenu("sidenav sidenavShow");
    }

    const hideMenu = () => {
        setDivBack(false);
        setShowMenu(menu);
    }

    const isMenuPinned = !isSmallWindow && menuPinned;
    const layoutClass = !isSmallWindow && !menuPinned
        ? "ini maxH menu-unpinned"
        : "ini maxH";

    return (
        <div className={layoutClass}>
            <div className={divBack ? "back" : "sr-only"} onClick={event => hideMenu()}></div>
            <AppSidenav profile={profile} show={showMenu} hide={hideMenu} link={handleClick} res={res}
                pinned={isMenuPinned} canPin={!isSmallWindow} onPinChange={setMenuPinned} />
            <AppHeader menu={showSidMenu} res={res} lan={lan} link={handleClick} />
            <div className="wrapper">
                <div className="push"></div>
                <div className="app-route-content">
                    {profileLoaded &&
                        <AppContent profile={profile} history={history} link={handleClick} res={res} />
                    }
                </div>
            </div>
            <AppFooter />
        </div>
    );
};
